import { Routes } from '@angular/router';
import { DashboardComponent } from '@features/dashboard/dashboard.component';
import { EmployeesComponent } from '@features/employees/employees.component';
import { SettingsComponent } from '@features/settings/settings.component';
import { AuthGuard } from '@auth/guards/auth.guard';
import { AUTH_ROUTES } from './auth/auth.routes';
import { SETTINGS_ROUTES } from '@features/settings/settings.routes';
import { RoleGuard } from '@auth/guards/role.guard';
import { UserSettingsComponent } from '@features/user-settings/user-settings.component';
import { ASSIGNMENTS_ROUTES } from '@features/assignments/assignments.routes';
import { REQUESTS_ROUTES } from '@features/requests/requests.routes';
import { CUSTOMERS_ROUTES } from '@features/customers/customers.routes';
import { twoFactorGuard } from '@auth/guards/two-factor.guard';
import { MunicipalityDocumentsComponent } from '@features/municipality-documents/municipality-documents.component';
import { KnowledgeItemsComponent } from '@features/knowledge-items/knowledge-items.component';
import { CustomerAppUsersComponent } from '@features/customer-app-users/customer-app-users.component';

export const routes: Routes = [
  ...AUTH_ROUTES,
  {
    path: '',
    canActivate: [AuthGuard, twoFactorGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        title: 'Dashboard',
        data: { name: 'Dashboard' },
      },
      {
        path: 'assignments',
        title: 'Opdrachten',
        children: ASSIGNMENTS_ROUTES,
      },
      {
        path: 'requests',
        title: 'Terugname aanvragen',
        children: REQUESTS_ROUTES,
      },
      {
        path: 'municipality-documents',
        component: MunicipalityDocumentsComponent,
        title: 'Documenten',
        data: { name: 'Documenten' },
      },
      {
        path: 'knowledge-items',
        component: KnowledgeItemsComponent,
        title: 'Kennisbank',
        data: { name: 'Kennisbank', role: ['ADMIN', 'BACKOFFICE'] },
        canActivate: [RoleGuard],
      },
      {
        path: 'customer-app-users',
        component: CustomerAppUsersComponent,
        title: 'App-gebruikers',
        data: { name: 'App-gebruikers', role: ['ADMIN'] },
        canActivate: [RoleGuard],
      },
      {
        path: 'customers',
        title: 'Klanten',
        children: CUSTOMERS_ROUTES,
      },
      {
        path: 'employees',
        component: EmployeesComponent,
        title: 'Medewerkers',
        data: { name: 'Medewerkers', role: ['ADMIN', 'KEY_USER'] },
        canActivate: [RoleGuard],
      },
      {
        path: 'settings',
        component: SettingsComponent,
        title: 'Beheer',
        data: { name: 'Beheer', role: ['ADMIN', 'BACKOFFICE'] },
        children: SETTINGS_ROUTES,
        canActivate: [RoleGuard],
      },
      {
        path: 'user-settings',
        component: UserSettingsComponent,
        title: 'Gebruikersinstellingen',
        data: { name: 'Gebruikersinstellingen' },
      },
      { path: '', redirectTo: 'assignments', pathMatch: 'full' },
      { path: '**', redirectTo: 'assignments' },
    ],
  },
];
